<div class="title" fxLayout="row" fxLayoutAlign="space-between end">
  <h1>{{'予約設問' | translate}}</h1>

  <div class="basic-button" fxLayoutGap="10px">
    <span></span>
    <button mat-raised-button color="primary" (click)="openAddDialog()">
      <mat-icon>add</mat-icon>
      <span>{{'追加' | translate}}</span>
    </button>

    <!-- <button mat-raised-button color="primary" (click)="openSortDialog()">
      <mat-icon>sort</mat-icon>
      <span>{{'並替' | translate}}</span>
    </button> -->

    <button mat-raised-button color="warn" (click)="deleteData()" [disabled]="!selection.selected.length">
      <mat-icon>delete</mat-icon>
      <span>{{'削除' | translate}}</span>
    </button>

  </div>
</div>

<div class="filter-field">
  <mat-form-field fxFlex="25%">
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" autocomplete="off" #input>
  </mat-form-field>
</div>

<div fxLayout="column" fxLayoutAlign="center center">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">

    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="64" style="text-align:center"> No. </th>
      <td mat-cell *matCellDef="let question; let i = index" style="text-align:right"> {{ (i + 1) + (paginator.pageSize
        * paginator.pageIndex) }} </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="80" style="text-align:center"> {{'編集' | translate}} </th>
      <td mat-cell *matCellDef="let question" style="text-align:center">
        <button mat-button color="primary" (click)="openEditDialog(question)">
          <mat-icon>create</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="50" style="text-align:center"> {{'削除' | translate}} </th>
      <td mat-cell *matCellDef="let row" style="text-align:center">
        <mat-checkbox color="warn" (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="question_id">
      <th mat-header-cell mat-sort-header *matHeaderCellDef [style.width.px]="100"> ID </th>
      <td mat-cell *matCellDef="let question" [style.width.px]="100"> {{ question.question_id }} </td>
    </ng-container>

    <ng-container matColumnDef="question_name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'設問' | translate}} </th>
      <td mat-cell *matCellDef="let question"> {{ question.question_names | multiQname:projectLanguages:projectBaseLang }}
      </td>
    </ng-container>

    <ng-container matColumnDef="question_type">
      <th mat-header-cell mat-sort-header *matHeaderCellDef [style.width.px]="120"> {{'設問タイプ' | translate}} </th>
      <td mat-cell *matCellDef="let question" [style.width.px]="120"> {{ question.question_type }} </td>
    </ng-container>

    <ng-container matColumnDef="questions">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="80" style="text-align:center"> {{'選択肢' | translate}} </th>
      <td mat-cell *matCellDef="let question" [style.width.px]="80" style="text-align:center">
        <span
          *ngIf="question.question_type != 'select' && question.question_type != 'checkbox' && question.question_type != 'radio'">
          ー ー </span>
        <span
          *ngIf="question.question_type == 'select' || question.question_type == 'checkbox' || question.question_type == 'radio'">{{
          question.question_select_items.length }} {{'件' | translate}}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="display_no">
      <th mat-header-cell mat-sort-header *matHeaderCellDef [style.width.px]="84" style="text-align:center"> {{'表示順' |
        translate}} </th>
      <td mat-cell *matCellDef="let question" [style.width.px]="60" style="text-align:center"> {{ question.display_no }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>
</div>